<template>
  <RF-Dialog
    :cpntStatus='statusGeral'
    :cpntRegistro='registro'
    :cpntLargura='"440px"'

    :cpntOnFecharDialog='regAteConfigStatusFormFecharFormulario'>
    <template slot='titulo' v-if='Object.keys(formulario).length >= 1'>
      <div style="display: inline-block; vertical-align: 9px;">
        <i aria-hidden="true" class="fa fa-angle-double-right"></i>
        <template v-if="registro.length === 1 && registro[0] === 0">
          Nova status
        </template>
        <template v-else-if="registro.length === 1 && registro[0] >= 1">
          Edição da status - {{ registro[0] }} 
        </template>
        <template v-else-if="registro.length >= 2">
          Editar Varios
        </template>
      </div>
    </template>

    <template slot='conteudo' v-if='Object.keys(formulario).length >= 1'>
      <RF-Formulario :data-time='time' class="reg-ate-config-status-form"
        style="margin-top: 20px;"

        :cpntTime='time'
        :cpntId='formulario.id' 
        :cpntStatus='formulario.status'
        :cpntField='formulario.field'
        :cpntUltAlt='formulario.ult_alt'
        :cpntButtons='formulario.buttons'

        :ref='formulario.id'
      ></RF-Formulario>
    </template>
  </RF-Dialog>
</template>

<style scoped>
</style>

<style>
  .reg-ate-config-status-form > .rf-form {
    text-align: center;
  }
    .reg-ate-config-status-form > .rf-form > .rf-toggles {
      margin-right: 0px !important;
    }
  .reg-ate-config-status-form > .rf-buttons-form {
    width: 390px;
  }
</style>

<script>
  export default {
    props: {
      cpntId: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntNomeDig: {
        required: false,
        type: [ String, Number ],
        default: function () {
          return ''
        }
      },
      cpntFecharFormulario: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        registro: [ ],
        formulario: {}
      }
    },
    mounted: function () {
      this.regAteConfigStatusFormIniciar()
    },
    methods: {
      regAteConfigStatusFormIniciar: function () {
        var self = this

        // SETA O STATUS DA PAGINA
        self.regAteConfigStatusFormSetaStatusGeral('carregando')

        // RESETA OS REGISTROS DA TELA
        self.registro = []

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // FAZ A VERIFICAÇÃO DO REGISTRO QUE ESTA SENDO TRABALHADO
        self.$store.state.CHECK_REGISTRO_FORM(self.cpntId, self.$route.params.id, function (reg, status) {
          // SETA O STATUS DA TELA
          self.regAteConfigStatusFormSetaStatusGeral(status)

          // VERIFICA SE DEU ALGUM ERRO
          if (status === '') {
            // SETA OS REGISTROS RECEBIDOS
            self.registro = reg

            // CHAMA A FUNÇÃO PARA INICIAR O FORMULARIO
            self.regAteConfigStatusFormFormularioIniciar()
          }
        })
      },
      regAteConfigStatusFormSetaStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      regAteConfigStatusFormFecharFormulario: function (atualizar, id = null, dados = null) {
        // VERIFICA SE DEVE BUSCAR OS DADOS ATUALIZADOS NA API
        if (atualizar === true && [ '', null, undefined ].indexOf(dados) !== -1 && [ '', null, undefined ].indexOf(id) === -1 && [ '', null, undefined ].indexOf(this.cpntFecharFormulario) === -1) {
          var self = this

          // SETA O QUERY GET NA API
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, where: { f: 'id', o: '=', v: id } }

          self.$store.state.comunicaAPI('/reg-atendimento/config/status/get/', 'GET', queryGet, function (apiSuccess) {
            self.regAteConfigStatusFormFecharFormulario(atualizar, id, apiSuccess.data[0])
          }, self.regAteConfigStatusFormSetaStatusGeral)
        } else {
          // CHAMA A FUNÇÃO PARA FECHAR O FORMULARIO
          this.cpntFecharFormulario(atualizar, id, dados)

          // VERIFICA O QUE DEVE SER FEITO COM O FORMULARIO
          switch (atualizar + '_' + this.formulario.inserirAcao) {
            case 'true_insMais':
              // LIMPA OS CAMPOS
              this.formulario.field.nome.value = ''
              this.formulario.field.nome.valueIni = ''

              this.formulario.field.nome.value = ''
              this.formulario.field.nome.valueIni = ''

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()

              // SETA O CAMPO QUE RECEBE O FOCUS
              this.$store.state.FUN_FOCUS_CAMPO_IN_FORM(this, 'formulario', 'nome', false)

              // COLOCA O STATUS DE CARREGANDO PARA O BUTTON
              this.regAteConfigStatusFormAlteraStatusButton()
              break

            default:
              // VERIFICA SE DEVE MUDAR A ROTA DO VUE
              if (this.cpntId === null) {
                this.$router.push({ name: 'reg_ate_config_status' })
              }
              break
          }
        }
      },
      regAteConfigStatusFormFormularioIniciar: function () {
        var self = this

        // LIMPA OS CAMPOS PARA SEREM INICIANDO NOVAMENTE
        self.formulario = {
          status: 'carregando',
          id: 'form-pet',
          field: {},
          tabIndexFieldGeral: 290001,
          tabIndexButtonGeral: 290002
        }

        // SETA O CAMPO NOME NO FORMULARIO
        self.formulario.field.nome = {
          tipo: 'input',
          tamanho: 2,
          nome: 'Nome',
          apiEnv: 'nome',
          apiRec: 'nome',
          value: self.cpntNomeDig,
          onChange: self.regAteConfigStatusFormOnChangeValue
        }
  
        self.formulario.field.mostrar = {
          tipo: 'toggles',
          tamanho: 3,
          nome: 'Notificar?',
          value: true,
          apiEnv: 'notificar',
          apiRec: '_notificar',
          onChange: self.regAteConfigStatusFormOnChangeValue
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // CRIA AS CHAVES PADROES DE TODOS OS COMPONENTS
        self.$store.state.FUN_CREATE_KEY_FIELDS(self.formulario.field, function (fields) {
          // SETA OS CAMPOS RECEBIDOS
          self.formulario.field = fields

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()

          // VERIFICA SE ESTA EDITANDO OU INSERIDO UM NOVO REGISTRO
          self.regAteConfigStatusFormSetarValores()
        })
      },
      regAteConfigStatusFormSetarValores: function () {
        if (this.registro.length === 1 && this.registro[0] === 0) {
          this.regAteConfigStatusFormFormularioFinalizar()
        } else {
          var self = this

          // CRIA O QUERY GET
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null, nome: null, notificar: null, last_at: null, last_user: { j: { usuario: null} } }, where: { f: 'id', o: 'in', v: self.registro.join() } }

          // COMUNICA COM A API
          self.$store.state.comunicaAPI('/reg-atendimento/config/status/get/', 'GET', queryGet, function (apiSuccess) {
            // CONVERTE O VALOR RECEBIDO
            apiSuccess.data[0]._notificar = [ '', null, undefined, false, 'false', 'n', 0, '0' ].indexOf(apiSuccess.data[0].notificar) === -1 ? true : false

            // SETA OS VALORES NOS CAMPOS
            self.$store.state.FUN_API_RET_SET_VALUE(self.formulario, apiSuccess.data[0], function (form) {
              // SETA OS CAMPOS RECEBIDOS
              self.formulario = form

              // CHAMA A FUNÇÃO PARA FINALIZAR O FORMULARIO
              self.regAteConfigStatusFormFormularioFinalizar()
            })
          }, self.regAteConfigStatusFormSetaStatusGeral)
        }
      },
      regAteConfigStatusFormFormularioFinalizar: function () {
        var self = this

        self.$store.state.FUN_CREATE_BUTTON_FORM(self.formulario.id, self.registro, self.cpntId, {
          env: function () {
            // SETA O TIPO DA ACÃO DE INSERIR
            self.formulario.inserirAcao = 'env'

            // COLOCA O STATUS DE CARREGANDO PARA O BUTTON
            self.regAteConfigStatusFormAlteraStatusButton('carregando')

            // CHAMA A FUNÇÃO PARA SALVAR O REGISTRO
            self.regAteConfigStatusFormSalvar()
          },
          insMais: function () {
            // SETA O TIPO DA ACÃO DE INSERIR
            self.formulario.inserirAcao = 'insMais'

            // COLOCA O STATUS DE CARREGANDO PARA O BUTTON
            self.regAteConfigStatusFormAlteraStatusButton('carregando')

            // CHAMA A FUNÇÃO PARA SALVAR O REGISTRO
            self.regAteConfigStatusFormSalvar()
          },
          can: function () {
            self.regAteConfigStatusFormFecharFormulario(false)
          }
        }, function (buttons) {
          // CRIA OS BUTTONS DO FORMULARIO
          self.formulario.buttons = buttons

          // SETA O STATUS PARA O FORMULARIO
          self.formulario.status = ''

          // SETA O CAMPO QUE RECEBE O FOCUS
          self.$store.state.FUN_FOCUS_CAMPO_IN_FORM(self, 'formulario', 'nome', false)
          
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        })
      },
      regAteConfigStatusFormOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTA SENDO ALTERADO
        var index = id.substring((this.formulario.id.length + 1), id.length)

        // SETA O VALOR RECEBIDO
        this.formulario.field[index].value = value

        // REMOVE A MENSAGEM DE ERRO
        this.formulario.field[index].mensagem = ''
        this.formulario.field[index].mensagemTipo = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      regAteConfigStatusFormAlteraStatusButton: function (status = '') {
        // COLOCA O STATUS DE CARREGANDO PARA O BUTTON
        this.formulario.buttons.env.status = status
        this.formulario.buttons.insMais.status = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      regAteConfigStatusFormSalvar: function () {
        var self = this

        self.$store.state.FUN_CREATE_FORM_API_FORMULARIO(self.formulario.field, {}, function (formData) {
          // VERIFICA SE DEVE INFORMAR O J_ID
          if (self.registro.length === 1 && self.registro[0] >= 1) {
            formData['id'] = self.registro[0]
          }

          // VERIFICA SE DEVE CONVERTER O VALOR DO CAMPO
          if ([ '', null, undefined ].indexOf(formData.notificar) === -1) {
            formData.notificar = [ true, 'true', 1, '1', 'S', 's' ].indexOf(formData.notificar) !== -1 ? 's' : 'n'
          }

          // CONVERTE O VALOR PARA LOTE
          formData = { lot: [ formData ]}

          // COMUNICA COM A API
          self.$store.state.comunicaAPI('/reg-atendimento/config/status', (formData.lot[0].hasOwnProperty('id') ? 'PUT' : 'POST'), formData, function (apiSuccess) {
            if (apiSuccess.hasOwnProperty('lot') && apiSuccess.lot[0].code !== '200') {
              // CONVERTE A MESAGEM RECEBIDA EM OBJETO
              if (typeof apiSuccess.lot[0].message === 'string') {
                apiSuccess.lot[0].message = { geralWeb: apiSuccess.lot[0].message }
              }

              self.$store.state.FUN_API_RET_VALIDA(self, 'formulario', apiSuccess.lot[0].message, apiSuccess.lot[0].code, self.formulario.field, true, function (form, focus) {
                // SETA OS CAMPOS COM OS ERROS
                self.formulario.field = form

                // SETA O CAMPO QUE RECEBE O FOCUS
                self.$store.state.FUN_FOCUS_CAMPO_IN_FORM(self, 'formulario', focus, false)

                // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
                self.regAteConfigStatusFormAlteraStatusButton('')

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()
              })
            } else {
              // CHAMA A FUNÇÃO PARA MOSTAR A MENSAGEM RECEBIDA DA API
              self.$store.state.TRATAR_RET_LOT_API(apiSuccess, function () {
                // CHAMA A FUNÇÃO PARA ATUALIZAR A TABELA
                self.regAteConfigStatusFormFecharFormulario(true, (apiSuccess.lot[0].hasOwnProperty('ref') && apiSuccess.lot[0].ref.hasOwnProperty('id')) ? apiSuccess.lot[0].ref.id : self.registro[0])
              })
            }
          }, self.regAteConfigStatusFormSetaStatusGeral, function (apiValid, apiStatus) {
            self.$store.state.FUN_API_RET_VALIDA(self, 'formulario', apiValid, apiStatus, self.formulario.field, true, function (form, focus) {
              // SETA OS CAMPOS COM OS ERROS
              self.formulario.field = form

              // SETA O CAMPO QUE RECEBE O FOCUS
              self.$store.state.FUN_FOCUS_CAMPO_IN_FORM(self, 'formulario', focus, false)

              // REMOVE O STATUS DE CARREGANDO PARA O BUTTON
              self.regAteConfigStatusFormAlteraStatusButton('')

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            })
          })
        })
      }
    }
  }
</script>
